$(document).ready(function() {
    $(".testimonial-quote").delay(10000).removeClass("preload");

    $amount_testimonials = $('.testimonial-text').length;
    $position = Math.floor(Math.random() * ($amount_testimonials - 1)) + 1;

    $('.testimonial-btn').click(function(){
        $direction = $(this).data('direction');
        $previous_position = 1;

        $('.testimonial-text').removeClass('show right-in left-in right-out left-out order-1 order-2 order-3');
        $('.testimonial-headline .fa-circle').removeClass('show');
        $('.testimonial-image-circle img').removeClass('show');

        if($direction == 'prev') {
            ($position > 1?$position--: $position = $amount_testimonials);
            ($position == $amount_testimonials)?$previous_position = 1: $previous_position = $position + 1;
            $out_class='left-out order-3';
            $in_class='right-in order-1';
        }
        else {
            ($position < $amount_testimonials?$position++:$position = 1);
            ($position == 1)?$previous_position = $amount_testimonials: $previous_position = $position - 1;
            $out_class='right-out order-3';
            $in_class='left-in order-1';
        }

        $('.testimonial-text[data-index=' + $previous_position + ']').addClass($out_class);


        $('.testimonial-text[data-index=' + $position + ']').delay( 2000 ).addClass($in_class);
        $('.testimonial-headline .fa-circle[data-index=' + $position + ']').delay( 800 ).addClass('show');
        $('#testimonial-image-' + $position).delay( 2000 ).addClass('show');

        $('.testimonial-text:not(.order-1,.order-3)').addClass('order-2');
    });

    $('.testimonial-headline .fa-circle, .testimonial-bullets .fa-circle').click(function(){
        $position = $(this).data('index');

        $('.testimonial-text').removeClass('show right-in left-in right-out left-out');
        $('.testimonial-headline .fa-circle, .testimonial-bullets .fa-circle').removeClass('show');
        $('.testimonial-image-circle img, .testimonial-inner-circle img').removeClass('show');

        $('.testimonial-text[data-index=' + $position + ']').delay( 400 ).addClass('show');
        $('.testimonial-headline .fa-circle[data-index=' + $position + '], .testimonial-bullets .fa-circle[data-index=' + $position + ']').delay( 400 ).addClass('show');
        $('#testimonial-image-' + $position).delay( 400 ).addClass('show');
    });
});